export const BASE_BUILD_DETAILS_URL = 'assets-global/build-details.json';
